import React from 'react';
import { Heart, Globe, Phone } from 'lucide-react';

const Footer = ({ variant = 'default', customColor }) => {
  const currentYear = new Date().getFullYear();

  // For self-registration page (full width, different styling)
  if (variant === 'registration') {
    return (
      <footer className="bg-gray-900 text-white py-8 border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Developer Credit */}
            <div className="flex items-center gap-2">
              <span className="text-gray-300">Developed by</span>
              <Heart className="h-4 w-4 text-red-500 fill-red-500 animate-pulse" />

              <a
                href="https://tchallasolutions.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="font-bold transition-colors"
                style={{ color: customColor || '#2dd4bf' }} // Default to teal-400
              >
                Tchalla Solutions
              </a>
            </div>

            {/* Contact Info */}
            <div className="flex flex-col md:flex-row items-center gap-4 text-sm text-gray-300">
              <a
                href="https://tchallasolutions.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-white transition-colors"
              >
                <Globe className="h-4 w-4" />
                <span>tchallasolutions.com</span>
              </a>
              <a
                href="https://wa.me/233501305096"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-white transition-colors"
              >
                <Phone className="h-4 w-4" />
                <span>+233 50 130 5096</span>
              </a>
            </div>
          </div>

          {/* Copyright */}
          <div className="text-center mt-6 pt-6 border-t border-gray-700">
            <p className="text-sm text-gray-400">
              © {currentYear} Tchalla Solutions. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    );
  }

  // Default footer for dashboard pages
  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Developer Credit */}
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <span>Developed with</span>
            <Heart className="h-4 w-4 text-red-500 fill-red-500 animate-pulse" />
            <span>by</span>
            <a
              href="https://tchallasolutions.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-primary-600 hover:text-primary-700 transition-colors"
            >
              Tchalla Solutions
            </a>
          </div>

          {/* Contact Info */}
          <div className="flex items-center gap-4 text-sm text-gray-500">
            <a
              href="https://tchallasolutions.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 hover:text-gray-700 transition-colors"
            >
              <Globe className="h-3.5 w-3.5" />
              <span className="hidden sm:inline">Website</span>
            </a>
            <span className="text-gray-300">|</span>
            <a
              href="https://wa.me/233501305096"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 hover:text-gray-700 transition-colors"
            >
              <Phone className="h-3.5 w-3.5" />
              <span>+233 50 130 5096</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
